import {filter, tidy} from '@tidyjs/tidy';

import type {BackgroundTasksStore} from './types';

export const interruptedTasksSelector = (state: BackgroundTasksStore) =>
  tidy(
    Array.from(state.tasks.entries()),
    filter(([_id, task]) => task.type === `PENDING` && !!task.isFetching && !task.payload),
  );

export const successfulTasksSelector = (state: BackgroundTasksStore) => {
  const items = tidy(
    Array.from(state.tasks.entries()),
    filter(([_id, task]) => task.type === `SUCCESS`),
  );

  // Return as map
  return new Map(items);
};

export const failedTasksSelector = (state: BackgroundTasksStore) =>
  new Map(
    tidy(
      Array.from(state.tasks.entries()),
      filter(([_id, task]) => task.type === `FAILURE`),
    ),
  );

export const pendingTasksSelector = (state: BackgroundTasksStore) =>
  new Map(
    tidy(
      Array.from(state.tasks.entries()),
      filter(([_id, task]) => task.type === `PENDING`),
    ),
  );
